import { request } from "@/api/client";
import type { EmailStatus } from "@/types/email";

export type EmailImapTestPayload = {
  email_address: string;
  imap_host: string;
  imap_port?: number;
  use_ssl?: boolean;
  username: string;
  password: string;
};

export function testImap(payload?: EmailImapTestPayload) {
  return request<EmailStatus>("/email/test_imap", {
    method: "POST",
    body: payload,
  });
}

export function disconnectImap() {
  return request<void>("/email/integration", {
    method: "DELETE",
  });
}
